import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DefaultButton, BasicModal } from 'common/components';
import { getLeanTechCustomerInfo } from '../../api';
import { staticStyles } from './style';

export const ConsentManagement = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [sdkLoaded, setSdkLoaded] = useState(false);

  // 根据 URL 判断是否为沙箱环境
  const isSandbox = () => {
    const hostname = window.location.hostname;
    return !hostname.startsWith('my.');
  };

  // Load Lean SDK script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.leantech.me/link/loader/prod/ae/latest/lean-link-loader.min.js';
    script.async = true;

    script.onload = () => {
      setSdkLoaded(true);
    };

    document.head.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  // Open Lean consent management
  const openLeanConsentManagement = async () => {
    if (!window.Lean || !window.Lean.manageConsents) {
      console.error('Lean SDK not loaded');
      return;
    }

    setLoading(true);

    try {
      // Get customer info from API
      const response = await getLeanTechCustomerInfo();
      const { data } = response;

      if (data && data.success) {
        window.Lean.manageConsents({
          app_token: data.app_token || '',
          customer_id: data.customer_id || '',
          access_token: data.sdk_token || '',
          sandbox: isSandbox(),
        });
      } else {
        console.error('Failed to get LeanTech customer info:', data?.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error fetching LeanTech customer info:', error);
    } finally {
      setLoading(false);
    }

    onClose();
  };

  return (
    <BasicModal captionId="manageConsents" isOpen={isOpen} onRequestClose={onClose}>
      <div className="consent-management-modal">
        <p className="consent-management-modal__description">
          <FormattedMessage
            id="consentManagementDescription"
            defaultmessage="Manage your bank account consents. You can view and revoke authorized consents."
          />
        </p>
        <div className="consent-management-modal__buttons">
          <DefaultButton
            textId="openConsentManagement"
            defaultmessage="Open Consent Management"
            filled
            onClick={openLeanConsentManagement}
            disabled={!sdkLoaded || loading}
          />
          <DefaultButton textId="justCancel" defaultmessage="Cancel" onClick={onClose} />
        </div>
      </div>

      <style jsx>{staticStyles}</style>
    </BasicModal>
  );
};

ConsentManagement.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConsentManagement;
